import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ConexionService } from './conexion.service';
import { UtilidadesService } from './utilidades.service';

@Injectable({
  providedIn: 'root'
})
export class ArchivosService {

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private alertController: AlertController) { }


  convertBlobToFile(blob, fileName, document) {
    let file = new File([blob], fileName, { type: blob.type, lastModified: new Date().getTime() });
    let container = new DataTransfer();
    container.items.add(file);
    let inputFile = document.createElement("input")
    inputFile.setAttribute("type", "file")
    inputFile["files"] = container.files;
    console.clear()
    return inputFile["files"]
  }




  async CompartirArchivo(titulo: string, texto: string, idarchivo, nombre, document) {

      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Comparte con todos',
        inputs: [
          {
            name: 'titulo',
            type: 'text',
            value: titulo,
            placeholder: 'Titulo'
          },
          {
            name: 'descripcion',
            type: 'textarea',
            value: texto,
            placeholder: 'Descripción'
          },
   
  
        ],
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
            }
          }, {
            text: 'Compartir',
            handler: (data) => {
              if (navigator["canShare"]) {
                this.utilidades.Loading("Obteniendo archivo")
                this.conexion.getFile(idarchivo, nombre).subscribe((resp) => {
                  this.utilidades.CerrarLoading()
                  
                  navigator.share({
                    files: this.convertBlobToFile(resp, nombre, document),
                    title: data.titulo,
                    text: data.descripcion,
                  })
                    .then(() => this.utilidades.Alerta("Se ha compartido exitosamente"))
                    .catch((error) => {
                      this.utilidades.Alerta("No se ha compartido"); console.log('Sharing failed', error)
    
                    });
          
                    this.conexion.deleteFileLocal(nombre).subscribe((resp)=>{
                      this.utilidades.Depuracion(resp, "console", "")
                    })
             
                }, (err) => {
                  this.utilidades.CerrarLoading()
                  this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
          
                  this.utilidades.ValidarUser(err)
                })
          
          
              } else {
                this.utilidades.Alerta("Tu sistema no es compatible")
              }
            }
          }
        ]
      });
  
      await alert.present();
    }

   
  }


